import React, { useState } from 'react';

import type { Homeless } from 'types';

import Card from '../components/Card';
import InfoCard from '../components/InfoCard';
import { getBonusFundAvailability } from '../bonusFunds';
import BaseProgressBar from './components/BaseProgressBar';

import { makeStyles } from '@mui/styles';
import ExtraProgressBar from './components/ExtraProgressBar';

const useStyles = makeStyles(() => ({
    bonusTrackerContainer: {
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        color: '#1F1F51',
        gap: '0px',
        boxShadow: '0px 8px 16px 4px #0000000D',
        borderRadius: '16px',
        overflow: 'hidden'
    },
    trackerBody: {
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '0px',
        padding: '0 0 0 0 !important',
        boxShadow: 'none !important',
        borderRadius: '0 0 16px 16px !important'
    }
}));

type BonusTrackerProps = {
    holder: Homeless;
};

const BonusTracker: React.FC<BonusTrackerProps> = ({
    holder
}) => {
    const classes = useStyles();
    const baseLimit = holder.action_step_bonus.base_limit;
    const baseUsed = holder.action_step_bonus.base_used;
    const scfLimit = holder.action_step_bonus.scf_limit ?? 0;
    const scfUsed = holder.action_step_bonus.scf_used ?? 0;
    const {
        assignableBase,
        assignableExtra,
        mcfYearlyDepleted,
        samaritanYearlyDepleted
    } = getBonusFundAvailability(holder);
    const [showTracker, setShowTracker] = useState(true);

    const cardStyle = {
        position: 'relative',
        backgroundColor: '#E7EFFE',
        zIndex: '1',
        borderRadius: showTracker ? '16px 16px 0 0' : '16px',
        boxShadow: 'none !important'
    };

    return (
        <div className={classes.bonusTrackerContainer}>
            <Card
                style={cardStyle as any}
                onClick={() => setShowTracker(!showTracker)}
            >
                <InfoCard open={showTracker} type="bonus" />
            </Card>
            {showTracker && (
                <Card
                    className={classes.trackerBody}
                >
                    <BaseProgressBar
                        used={baseUsed}
                        limit={baseLimit}
                        name={holder.name}
                        extraUsed={scfUsed}
                        extraLimit={scfLimit}
                        extraYearlyDepleted={mcfYearlyDepleted}
                        remaining={assignableBase}
                        samaritanYearlyDepleted={samaritanYearlyDepleted}
                    />
                    <ExtraProgressBar
                        used={scfUsed}
                        limit={scfLimit}
                        baseUsed={baseUsed}
                        baseLimit={baseLimit}
                        name={holder.name}
                        mcfYearlyDepleted={mcfYearlyDepleted}
                        remaining={assignableExtra}
                        samaritanYearlyDepleted={samaritanYearlyDepleted}
                    />
                </Card>
            )}
        </div>
    );
};

export default BonusTracker;
